import React from 'react';

import './page-header.scss';

// centred eyebrow, serif title and subtitle at the top of content pages, as on the About page
export default ({ eyebrow, title, children }) => (
  <header className="page-header">
    {eyebrow ? (
      <div className="eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">{eyebrow}</span>
        <div className="eyebrow-line"></div>
      </div>
    ) : null}
    <h1 className="section-title">{title}</h1>
    {children ? <div className="section-sub">{children}</div> : null}
  </header>
);
